import { importProvidersFrom, NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '../ntx-app/modules/ntx-core/auth/guards/auth-guard.service';
import { ClientStorageResolver } from "./shared/resolvers/client-storage-resolver";
import { CustomReuseStrategy } from './app-routing-reuse-strategy';
import { Key, LucideAngularModule, Settings, Settings2, TrendingDown, TrendingUp } from 'lucide-angular';
import { ReportsDemoGuardService } from '../ntx-app/modules/ntx-demos/reports-demo/reports-demo.guard.service';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('../ntx-app/modules/ntx-demos/reports-demo/reports-demo.module').then(mod => mod.ReportsDemoModule),
    resolve: [ClientStorageResolver],
    canMatch: [ReportsDemoGuardService]
  },
  {
    path: '',
    canActivate: [AuthGuardService],
    resolve: [ClientStorageResolver],
    loadChildren: () => import('./core/core.module').then(mod => mod.CoreModule),
    providers: [importProvidersFrom(LucideAngularModule.pick({ Settings, TrendingUp, TrendingDown, Settings2, Key }))]
  },
  {
    path: 'auth',
    loadChildren: () => import('../ntx-app/modules/ntx-core/auth/auth.module').then(mod => mod.AuthModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  providers: [{ provide: RouteReuseStrategy, useClass: CustomReuseStrategy }],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
